import { render, staticRenderFns } from "./RefereeDetails.vue?vue&type=template&id=c7c6bb96&scoped=true&"
import script from "./RefereeDetails.vue?vue&type=script&lang=js&"
export * from "./RefereeDetails.vue?vue&type=script&lang=js&"
import style0 from "./RefereeDetails.vue?vue&type=style&index=0&id=c7c6bb96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7c6bb96",
  null
  
)

export default component.exports